<template>
    <div class="topcode-wechat-player">
        <YingshiPlayer v-if="'1270627954151059458'===productId" productName="安消摄像机"
                       :sn="sn" :accessToken="accessToken"/>
        <YingshiPlayer v-else-if="'1270627284745777154'===productId" productName="云台摄像机"
                       :sn="sn" :accessToken="accessToken"/>
        <YingshiPlayer v-else-if="'1270627504376311809'===productId" productName="高清球机"
                       :sn="sn" :accessToken="accessToken"/>
        <YingshiPlayer v-else-if="'1270628169079779330'===productId" productName="可视化烟感"
                       :sn="sn" :accessToken="accessToken"/>
        <div v-else-if="'1278520532375302146'===productId">
            <HlsPlayer v-if="isIos" productName="全球眼" :sn="sn"/>
            <FlvPlayer v-else productName="全球眼" :sn="sn"/>
        </div>
        <!--<div v-else>该设备暂不支持播放视频</div>-->
    </div>
</template>

<script>
    import FlvPlayer from "./FlvPlayer"
    import HlsPlayer from "./HlsPlayer"
    import YingshiPlayer from "./YingshiPlayer"

    export default {
        components: {
            FlvPlayer, HlsPlayer, YingshiPlayer
        },
        props: {},
        data() {
            return {
                deviceDetail: {},
                accessToken: '',
                capacity: '',
                playerType: 'Yingshi',
                sePlayerUrl: ''
            }
        },
        computed: {
            productId() {
                return this.deviceDetail.productId
            },
            sn() {
                return this.deviceDetail.sn || ""
            },
            title() {
                return this.deviceDetail.name || ""
            },
            params() {
                const {title, sn, accessToken, playerType, capacity} = this
                return {title, sn, accessToken, playerType, capacity}
            },
            isIos() {
                return window.__wxjs_is_wkwebview
            }
        },
        created() {
        },
        mounted() {
            this.getDeviceDetail()
        },
        methods: {
            getDeviceDetail() {
                this.$http.tokiot.device.get({id: this.$route.params.id, allShadowProp: true})
                    .then(ret => {
                        if (ret) {
                            this.deviceDetail = ret
                            if ("1278520532375302146" == ret.productId) this.playerType = "Flv"
                            ret.shadowProp.forEach(item => {
                                if ("accessToken" == item.code) this.accessToken = item.value
                                if ("capacity" == item.code) this.capacity = item.value
                            })

                        }
                    })
            },
        },
        watch: {}
    }
</script>

<style lang="less" scoped>
</style>